(($) => {
  // Setup a timer
  let timeout;

  function setContentHeight() {
    if ($('body').length) {
      const windowHeightSP = $(window).height();

      $('body').css({ height: 'auto' });
      $('html').css({ height: 'auto' });
      $('#main-wrapper').css({ height: 'auto' });
      const bodyHeight = $('body').outerHeight();
      const mainContentSP = $('#main-wrapper').outerHeight();

      if (windowHeightSP > bodyHeight) {
        const newMainContentHeightSP =
          windowHeightSP - bodyHeight + mainContentSP;

        $('#main-wrapper').css('min-height', `${newMainContentHeightSP}px`);
      }
    }
  }

  // Listen for DOM Ready events.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      setContentHeight();
    },
    false,
  );

  // Listen for resize events.
  window.addEventListener(
    'resize',
    () => {
      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(() => {
        setContentHeight();
      });
    },
    false,
  );
})(jQuery);
